<script setup lang="ts">
import { SITEURL } from "@libTs/cms.globals";
import { itemCodeToUrlSlug } from "../helpers/url.helper";
import { ref } from "vue";

const { products } = defineProps({
    products: {
        type: Array,
        required: true,
    },
});

const sliderEl = ref<JQLite>();
</script>
<template>
    <div class="col-start-3 col-end-23 home-news-slider-wrapper">
        <div
            class="slider-simple"
            ref="sliderEl"
            data-responsive='[
                {
                    "breakpoint": 9999,
                    "settings": {
							"slidesToShow": 4
                    }
                },
                {
                    "breakpoint": 1401,
                    "settings": {
						 "slidesToShow": 3
                    }
                },
                {
                    "breakpoint": 1201,
                    "settings": {
                        "slidesToShow": 2
                    }
                },
                {
                    "breakpoint": 769,
                    "settings": {
                        "slidesToShow": 1
                    }
                },
                {
                    "breakpoint": 501,
                    "settings": {
                        "slidesToShow": 1
                    }
                }
            ]'
        >
            <div v-for="product in products" class="home-news-cell">
                <a
                    class="home-news-link"
                    :href="SITEURL + 'product/' + itemCodeToUrlSlug(product.ItemCode)"
                >
                    <div class="home-news-body">
                        <img
                            v-if="product.mainImage"
                            class=""
                            :src="product.mainImage"
                            :alt="product.ItemName"
                        />
                        <img
                            v-else
                            class=""
                            :src="SITEURL + '/assets/no-image.png'"
                            alt="No image available"
                        />

                        <div class="news-title">{{ product.ItemName }}</div>
                        <div class="news-lead">{{ product.ItemCode }}</div>
                    </div>

                    <div class="home-news-learnmore">
                        Learn more
                        <i class="fas fa-arrow-right"></i>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>
